import { useMediaQuery } from 'react-responsive'
import ResponsiveComponent from '@/components/ResponsiveComponent'

import ProductFullBleedHero from '@/components/Sections/ProductFullBleedHero'
import ProductFiftyFifty from '@/components/Sections/ProductFiftyFifty'
import ThreeImageBlock from '@/components/Sections/ThreeImageBlock'
import ProductFullStaticBleedHero from './ProductFullStaticBleedHero'

const SustainabilityAndCommunity = ({ sections }) => {
  let hero;
  let halfContentBlock;
  let threeImageBlock;

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  sections[0].sections.map((section) => {
    const type = section?._type;

    switch (type) {
      case 'dynamicHero':
        hero = section;
      case 'halfContentBlock':
        halfContentBlock = section;
      case 'threeImageBlock':
        threeImageBlock = section;
    }
  })

  return (
    <>
      {(hero && <ProductFullBleedHero
        fields={hero}
        imagePriority={true}
        key={hero._key}
      />
      )}
      <ResponsiveComponent
        desktopBreakpoint={'sm'}
        mobile={
          <ProductFullStaticBleedHero />
        }
        desktop={
          <>
            <ProductFiftyFifty fields={halfContentBlock} key={halfContentBlock._key} />
            <ThreeImageBlock fields={threeImageBlock} key={threeImageBlock._key} />
          </>
        }
      />
    </>
  );
};

export default SustainabilityAndCommunity;
